import Proptypes from 'prop-types'
import { isPartVisible } from 'utils/displayByDateAndTime'
import ListItem from 'components/ListItem'
import Input from 'components/Input'
import Trigger from 'components/Trigger'
import Lotodemo from 'components/Lotodemo'
import Lotodemoembed from 'components/Lotodemoembed'
import Lotodemolegend from 'components/Lotodemolegend'
import Lotodemobabies from 'components/Lotodemobabies'
import Lotodemofreespins from 'components/Lotodemofreespins'
import Lotodemoreelways from 'components/Lotodemoreelways'

import { countVisit } from '../../../store/actions/app'

export const PartAdvancedModule = ({ part, visitorId, appInfos, cardInfos }) => {
  if (!isPartVisible(part)) return null

  switch (part.type) {
    case 'VisitCounter':
      countVisit(part, appInfos.id, cardInfos.cardId, cardInfos.tokenId, visitorId)
      return null
    case 'Trigger':
      return <Trigger appId={appInfos.id} id={part.id} type="trigger" typeId={part.id} />
    case 'Lotodemo':
      return <Lotodemo appId={appInfos.id} id={part.id} type="lotodemo" />
    case 'Lotodemoembed':
      return <Lotodemoembed appId={appInfos.id} id={part.id} type="lotodemoembed" />
    case 'Lotodemolegend':
      return <Lotodemolegend appId={appInfos.id} id={part.id} type="Lotodemolegend" />
    case 'Lotodemobabies':
      return <Lotodemobabies appId={appInfos.id} id={part.id} type="Lotodemobabies" />
      case 'Lotodemofreespins':
      return <Lotodemofreespins appId={appInfos.id} id={part.id} type="Lotodemofreespins" />
      case 'Lotodemoreelways':
      return <Lotodemoreelways appId={appInfos.id} id={part.id} type="Lotodemoreelways" />
    case 'ListItem':
      return (
        <ListItem appId={appInfos.id} id={part.id} displayType={part.style ? part.style.displayType : ''} />
      )
    case 'Input':
      return <Input appId={appInfos.id} id={part.id} displayType={part.displayType} />
    default:
      return null
  }
}

PartAdvancedModule.propTypes = {
  part: Proptypes.object,
  visitorId: Proptypes.any,
  appInfos: Proptypes.object,
  cardInfos: Proptypes.object,
}

export default PartAdvancedModule
